import { ajaxSetup, ajax, getJSON } from 'jquery'
import {IOptions} from "../options";
import { buildUrl, getConfig } from '../components/Utils'
// import { URL } from 'url';
import { store } from '../store';
// import { openAlert } from "../actions";
import {OPEN_MODAL} from "../actions/ActionTypes";

export interface IHandler {
    (...params: any[]): void;
}

export interface IErrorHandler {
    (status: number, error: string): void;
}

export interface IProgressHandler {
    (progress: number): void;
}

export interface IHandlers {
    before?: IHandler;
    success?: IHandler;
    error?: IErrorHandler;
    progress?: IProgressHandler;
}

export interface IFileOptions {
    id: string;
    maxSize: number;
    format: string;
    element: HTMLInputElement;
}

interface RequestOptions {
    url: string;
    method: string;
    contentType?: string | boolean;
    xhr?: () => XMLHttpRequest;
    processData?: boolean;
    data?: any;
}

export function createApiClient(form:string = null){
    let formates = {
        "PDF": ["PDF"],
        "Image": ["JPG","PNG","JPEG"]
    };

    ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    })

    let config = getConfig();
    if(form !== null){
        config.id = form
    }
    config.filesUrl = `${config.filesUrl}/${config.id}/${config.valuesId}`;

    return new ApiClient(config, formates, false)
}

const errorHandler = (_, response) => {
    const { errors } = JSON.parse(response);
    console.log('errors:', errors, ' response:', response);
    if(errors.length > 0){
        if(errors[0].error.code === '400'){
            alert(errors[0].error.message);
            window.location.reload();
        }
    }
}

//Если обработчик ошибок не указан явно, применяем этот везде как дефолтный (на всех запросах)
const sendDefaultErrorHandler = (status, error) => {
    const { dispatch } = store;
    const errorMessage = typeof (error.errorMsg ? error.errorMsg : error) === 'string' ? (error.errorMsg ? error.errorMsg : error) : 'Неизвестная ошибка';

    dispatch({
        type: OPEN_MODAL,
        payload: errorMessage
    });
}

export class ApiClient {

    private lock: boolean;
    private options: IOptions;
    private setValueUrl: string;
    private urlApi: string;
    private userApi:string;
    private actionUrl: string;
    private baseUrl: string;

    public readonly FileFormats: {[format:string]: Array<string>};

    constructor(options: IOptions, formats: {[format:string]: Array<string>}, lock: boolean) {
        this.options = options;
        this.setValueUrl = this.options.apiUrl + "/" + this.options.id + "/" + this.options.valuesId;
        this.actionUrl = this.options.apiUrl + "/action/" + this.options.id + "/" + this.options.valuesId;
        this.urlApi = this.options.apiUrl;
        this.userApi = this.options.apiUser;
        this.baseUrl = this.options.apiUrl ? this.options.apiUrl.substring(0, this.options.apiUrl.length - 6) : "";

        this.FileFormats = formats;

        this.lock = lock;
    }

    public isLocked() {
        return this.lock;
    };

    public getReportUrl({ formId, valuesId, type }: { formId:string, valuesId: string, type?: 'one' | 'two' }){
        const baseReportPath = {
            one: 'report_one',
            two: 'report_two',
            undefined: 'report',
        }[type]

        return `${this.userApi}/${baseReportPath}/${formId}/${valuesId}`;
    }

    public getAttachFileUrl(formId:string, valuesId: number,uid:string){
        return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files`;
    }

    public createSession(formId:string, company: any, handlers: IHandlers){

        const companyAdapter = {
            address: company.company_legal_address,
            companyFullName: company.company_short_name.ru,
            companyName: company.company_full_name.ru,
            companyProjectName: company.company_project_name,
            date: company.company_status_add_date,
            inn: company.company_inn,
            kpp: company.company_kpp,
            ogrn: company.company_ogrn,
            orn: company.company_orn,
        }

        this.send({
            url: `${this.urlApi}/${formId}`,
            method: 'POST',
            contentType: "application/json",
            data: JSON.stringify(companyAdapter)
        },handlers);
    }

    public me(handlers: IHandlers){
        getJSON(`${this.userApi}/me/`, handlers.success);
    }

    public getSettings(handlers: IHandlers){
        getJSON( `${this.userApi}/settings/`, handlers.success);
    }

    public getNotify(formId:string, values:number, handlers: IHandlers){
        getJSON(`${this.urlApi}/notify/${formId}/${values}`, handlers.success);
    }

    public getHistory(form:string, values:number, handlers: IHandlers){
        getJSON(`${this.userApi}/history/${form}/${values}`, handlers.success);
    }

    public company(handlers: IHandlers){
        getJSON(`${this.userApi}/company/`, handlers.success);
    }

    public getCompanyORN(inn: string, handlers: IHandlers){
        getJSON(`${this.userApi}/company/orn/${inn}`, handlers.success)
            .fail(handlers.error);
    }

    public redirect(url:string){
        window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(window.location.href)}`;
    }

    public singout(url:string){
        window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(window.location.href)}`;
    }

    public sendValues(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/send",
            method: "POST"
        }, handlers);
    }

    public sendDocument(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/document",
            method: "POST"
        }, handlers);
    }

    public sendRevoke(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/revoke",
            method: "POST"
        }, handlers);
    }


    public sendAdditional(handlers: IHandlers){
        this.send({
            url: this.actionUrl + "/additional",
            method: "POST"
        }, handlers);
    }

    public sendPDF(handlers: IHandlers){
        this.send({
            url: this.actionUrl + "/pdf",
            method: "POST"
        }, handlers);
    }

    public cloneRequest(handlers: IHandlers){
        this.send({
            url: `${this.actionUrl}/clone`,
            method: "POST"
        }, handlers);
    }

    public deleteValues(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/delete",
            method: "DELETE",
        }, handlers);
    }

    public sendReport({data, formId, valuesId, action}, handlers: IHandlers) {
        this.send({
            url:  `${this.urlApi}/${formId}/${valuesId}/${action}`,
            method: 'POST',
            data,
            contentType: false,
            processData: false,
        }, handlers)
    }

    public getFileUrl(controlId: string, fileName: string, timestamp?: number): string {
        if(timestamp !== undefined)
            fileName = timestamp + "/" + fileName;
        return encodeURI(`${this.options.filesUrl}/${controlId}/${fileName}`);
    }

    public setValue(id: string, value: any, handlers: IHandlers = null) {
        handlers.error = errorHandler;

        this.send({
            url: this.setValueUrl + "/" + id,
            method: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({timestamp: Date.now(), value})
        }, handlers);
    }

    public setValueSync(id: string, value: any, handlers: IHandlers = null) {
        this.send({
            url: this.setValueUrl + "/" + id,
            method: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({timestamp: Date.now(), value})
        }, handlers, false);
    }

    public putValue(id: string, value: any, handlers: IHandlers = null): number {
        const timestamp = Date.now();

        this.send({
            url: this.setValueUrl + "/" + id,
            method: "PUT",
            contentType: "application/json",
            data: JSON.stringify({timestamp: timestamp, value: value})
        }, handlers);
        return timestamp;
    }

    public removeValue(id: string, timestamp: number, handlers: IHandlers = null) {
        handlers.error = errorHandler;
        this.send({
            url: this.setValueUrl + "/" + id + "/?timestamp=" + timestamp,
            method: "DELETE"
        }, handlers);
    }

    public removeReportPdf({formId, valuesId, type, handlers = null}: {formId: string, valuesId: string, type?: 'one' | 'two', handlers: IHandlers}){
        const baseReportPath = {
            one: 'report_one',
            two: 'report_two',
            undefined: 'report',
        }[type]

        this.send({
            url: `${this.options.apiUrl}/${formId}/${valuesId}/${baseReportPath}`,
            method: "DELETE"
        }, handlers);
    }

    public setFileValue(options: IFileOptions, value: any, fileId: string, handlers: IHandlers): string {
        const file = options.element.files[0];
        if(file == undefined || file == null)
            return null;

        const data = new FormData();
        data.append("file", file);
        data.append("value", value);
        data.append("fileId", fileId);

        let success : IHandler = null;
        if (handlers != null && handlers.success != null) {
            success = handlers.success;
            handlers.success = function (res) {
                success(res);
            }
            handlers.error = errorHandler;
        }

        this.send({
            xhr: function (): XMLHttpRequest {
                const xhr = new XMLHttpRequest();
                if(handlers != null && handlers.progress != null) {
                    xhr.upload.addEventListener("progress", e => {
                        handlers.progress(e.loaded / e.total * 100)
                    });
                }
                return xhr;
            },
            url: this.setValueUrl + "/" + options.id + "/file",
            method: "POST",
            contentType: false,
            data: data,
            processData: false
        }, handlers);
    }

    public deleteFileValue(id: string, fileName: string,value:any, fileId:string, handlers: IHandlers) {
        const data = new FormData();
        data.append("value", value);
        data.append("fileId", fileId);

        handlers.error = errorHandler;

        this.send({
            url: encodeURI(this.setValueUrl + "/" + id + "/" + fileName),
            method: "DELETE",
            contentType: false,
            data,
            processData: false
        }, handlers);
    }

    public getFormByUid(id: string,values:number,  handlers: IHandlers){
        getJSON(`${this.urlApi}/${id}/${values}`, handlers.success)
            .fail(handlers.error);
    }

    public getAllValues(handlers: IHandlers){
        getJSON(this.urlApi, handlers.success)
            .fail(handlers.error);
    }

    public getOptions(optionsUrl: string, handlers: IHandlers) {
        const optionsUrlSubstituted = buildUrl(optionsUrl, this.options)
        getJSON(`${this.baseUrl}${optionsUrlSubstituted}`, handlers.success)
            .fail(handlers.error);
    }

    public openForm(valuesId: string, formId:string, handlers: IHandlers){
        getJSON(`${this.urlApi}/values/${valuesId}/${formId}`,handlers.success)
            .fail(handlers.error);
    }

    public companyInfo(inn:string, handlers: IHandlers){
        getJSON(`${this.userApi}/company/${inn}`,handlers.success)
            .fail(handlers.error);
    }

    public getCompanies(handlers: IHandlers){
        getJSON(`${this.userApi}/my_companies`,handlers.success)
            .fail(handlers.error);
    }

    public getProjects(orn:string, handlers: IHandlers){
        getJSON(`${this.userApi}/my_projects/${orn}`,handlers.success)
            .fail(handlers.error);
    }

    public suggest(text:string, handlers: IHandlers){
        this.send({
            url: `${this.userApi}/suggest`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({query: text})
        },handlers);
    }

    public getValue(controlId:string, handlers: IHandlers){
        this.send({
            url: this.setValueUrl + "/" + controlId,
            method: "GET",
        },handlers)
    }

    public isRemovePanelBlock(key:string, handlers: IHandlers){
        this.send({
            url: `${this.setValueUrl}/${key}/isremove`,
            method: "GET"
        }, handlers)
    }

    public hasRemoveBlock(key:string, handlers: IHandlers){
        this.send({
            url: `${this.setValueUrl}/${key}/hasremove`,
            method: "GET"
        }, handlers)
    }

    private send(options: RequestOptions, handlers: IHandlers, async: boolean = true) {
        let success: IHandler = null;
        let error: IErrorHandler = null;
        if(handlers) {
            success = handlers.success;
            error = handlers.error;
        }

        ajax({
            xhr: options.xhr,
            url: options.url,
            type: options.method,
            contentType: options.contentType,
            data: options.data,
            processData: options.processData,
            success: success,
            async,
            error: function (jqXHR: JQueryXHR) {
                if(error != null) {
                    error(jqXHR.status, jqXHR.responseText);
                } else {
                    sendDefaultErrorHandler(jqXHR.status, jqXHR.responseText);
                }
            },
        });
    }

    private static getFileExtension(fileName: string) {
        return fileName.substring(fileName.lastIndexOf(".") + 1).toUpperCase();
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiClient.tsx